import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

// Constants
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'
import { ESS_WIN } from '../../../../../constants/wins'

// Selectors
import { selectFirstPriceBracketPocketAmount } from '../../../../../store/selectors/home/equity'

// Contexts
import { useTheme } from '@homebotapp/hb-react-component-catalog'

// Components
import { Format, Text } from '../../../..'
import { idForScroll } from '../../../MarketSpotlight/EquitySmartSearchTable/EquitySmartSearchTable'
import { ImportantNowCard } from '../../ImportantNowCard'

// Assets
import DefaultThemeSvg from './DefaultThemeSvg'
import LightThemeSvg from './LightThemeSvg'

const Ess = () => {
  const downsizeSavings = useSelector(selectFirstPriceBracketPocketAmount)
  const { theme } = useTheme()

  const Svg = theme.isLightThemeType ? LightThemeSvg : DefaultThemeSvg

  return (
    <ImportantNowCard
      winType='Ess'
      svgImage={Svg}
      navTo={`${OVERLAY_HELPERS.marketSpotlight.buildPath()}#${idForScroll}`}
      tracking={{
        guid: 'xQo7jVg5H7VWk7x5LfxBhKs',
        ui_context: 'homeownerDashboardWinEss',
        descriptor: 'User clicked on Ess card in Whats Important Now section in Homeowner Dashboard'
      }}
    >
      <FormattedMessage
        id='ImportantNow.spotlight.ess'
        defaultMessage='You could downsize and pocket around {essSavings} of cash'
        values={{
          essSavings: (
            <Text element='span' weight='semibold' variant='success'>
              <Format.Currency abbreviate value={downsizeSavings} />
            </Text>
          )
        }}
      />
    </ImportantNowCard>
  )
}

Ess.propTypes = {}

export default Ess
